import React from 'react';
import styles from './TimeInput.module.css';

export default function TimeInput({ value, onChange, label, className = '' }) {
  const normalizeTo15Min = (timeValue) => {
    if (!timeValue || !timeValue.includes(':')) return '00:00';

    const [h, m] = timeValue.split(':').map(Number);
    const totalMinutes = (h * 60) + m;
    const rounded = Math.round(totalMinutes / 15) * 15;
    const normalizedHours = Math.floor((rounded % 1440) / 60);
    const normalizedMinutes = rounded % 60;

    return `${String(normalizedHours).padStart(2, '0')}:${String(normalizedMinutes).padStart(2, '0')}`;
  };

  const handleChange = (e) => {
    onChange(normalizeTo15Min(e.target.value));
  };

  return (
    <div className={`${styles.timeInput} ${className}`.trim()}>
      <label>{label}</label>
      <div className={styles.inputs}>
        <input
          type="time"
          step="900"
          value={normalizeTo15Min(value)}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
